// Bunny implements the Player.js message protocol:
// https://bunny.net/docs/stream/playback-api
// https://github.com/embedly/player.js/blob/master/SPEC.rst
const EVENTS=['play','pause','ended','timeupdate','seeked','error'];
let nextListener=0;
export function parsePlayerValue(value) {
    if(typeof value!=='string')return value;
    try{return JSON.parse(value);}catch{return value;}
}
export function connectBunnyPlayer(frame,onEvent) {
    const origin=new URL(frame.src).origin;
    const listener=`instil-${++nextListener}`;
    let ready=false,disposed=false,durationKnown=false;
    const send=(method,value)=>{
        if(disposed)return;
        try {frame.contentWindow?.postMessage(JSON.stringify({context:'player.js',version:'0.0.11',method,value,listener}),origin);} catch { /* The frame may already be detached or navigating away. */ }
    };
    const receive=event=>{
        // Neither another iframe nor another origin can control this video's state.
        if(disposed || event.origin!==origin || event.source!==frame.contentWindow)return;
        const message=parsePlayerValue(event.data);
        if(!message || message.context!=='player.js')return;
        const value=parsePlayerValue(message.value);
        if(message.event==='ready') {
            if(ready)return;
            ready=true;
            EVENTS.forEach(name=>send('addEventListener',name));
            onEvent('ready',value);
            // Synchronize if playback started before the bridge connected.
            send('getPaused');send('getCurrentTime');send('getDuration');
        } else if(ready && message.listener===listener && (EVENTS.includes(message.event) || ['getPaused','getCurrentTime','getDuration'].includes(message.event))) {
            if(message.event==='getDuration' && playbackPosition(value)>0)durationKnown=true;
            onEvent(message.event,value);
        }
    };
    const handshake=()=>{if(!ready)send('addEventListener','ready');};
    window.addEventListener('message',receive);
    frame.addEventListener('load',handshake);
    handshake();
    const disconnect=()=>{
        EVENTS.forEach(name=>send('removeEventListener',name));
        send('removeEventListener','ready');
        disposed=true;
        window.removeEventListener('message',receive);
        frame.removeEventListener('load',handshake);
    };
    // Query even when timeupdate/seeked stop firing during a failed seek.
    disconnect.requestState=()=>{
        if(!ready || disposed)return;
        send('getPaused');send('getCurrentTime');
        // Ready can arrive before video metadata, when duration is still zero.
        if(!durationKnown)send('getDuration');
    };
    return disconnect;
}

export function playbackPosition(value) {
    const data=parsePlayerValue(value);
    const seconds=typeof data==='object' && data!==null ? data.seconds : data;
    // Ignore null, booleans and empty strings instead of treating them as zero.
    if((typeof seconds!=='number' && typeof seconds!=='string') || String(seconds).trim()==='')return null;
    const number=Number(seconds);
    return Number.isFinite(number) && number>=0 ? number : null;
}

export function parsePlaybackTime(value) {
    const text=String(value).trim();
    if(!/^\d{1,6}(:[0-5]\d){0,2}$/.test(text))return null;
    const seconds=text.split(':').reduce((total,part)=>total*60+Number(part),0);
    return seconds<=259200 ? seconds : null;
}
export function formatPlaybackTime(seconds) {
    const total=Math.max(0,Math.floor(Number(seconds)||0));
    const hours=Math.floor(total/3600),minutes=Math.floor(total/60)%60;
    return `${hours?`${hours}:`:''}${hours?String(minutes).padStart(2,'0'):Math.floor(total/60)}:${String(total%60).padStart(2,'0')}`;
}
